module.exports = __webpack_public_path__ + "public/SiteIcons/arrowGreen.svg?1be3aadd";